"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dueDateAggregate = void 0;
const flattenDeep_1 = __importDefault(require("lodash-es/flattenDeep"));
const date_1 = require("../utils/date");
const field_logic_1 = require("../field-type-registry/field-logic");
function dueDateAggregate(aggregate) {
    return (0, field_logic_1.valuesAggregator)((values, logic, field, userPreferences) => {
        // TODO: The Lookup field uses this aggregations without modifications. It is necessary to
        //  rewrite receiving aggregations through a function as receiving filtering functions (getComparisons).
        //  Move logic flatten to Lookup field logic
        const dates = (0, flattenDeep_1.default)(values)
            .filter((value) => !logic.isValueEmpty(value, field))
            .map((value) => ({
            date: value.to_date,
            momentDate: (0, date_1.dateToMoment)(value.to_date, userPreferences),
        }));
        return aggregate(dates, field, userPreferences, field.params.display_format);
    });
}
exports.dueDateAggregate = dueDateAggregate;
